export default __webpack_public_path__ + "static/media/comission-table.946f706a.jpg";